import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import ConnectSVG from '../../../../img/startPage/nonRedtailConnect.svg';
import { Separator } from '../../../CommonComponents/OPL/Separator/Separator';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Link } from '../../../CommonComponents/OPL/Link/Link';
import { sampleClientsSelector } from '../../../AdviserArea/AdviserAreaSelector';

interface Props {
  onClose: () => void;
}

export const NonRedtailWelcome = ({ onClose }: Props) => {
  const sampleClients = useSelector(sampleClientsSelector);
  const demoURI = ADV.settings.endpoints.demo;

  return (
    <>
      <ModalHeader as="h2" id="modal-header" hasBorder>
        Welcome to Orion Planning
      </ModalHeader>

      <ModalCloseButton
        onClick={() => {
          onClose();
        }}
      />

      <ModalBody>
        <Box
          display="flex"
          flexDirection="column"
          css={({ theme }) => ({ gap: theme.space['16'] })}
          width="100%"
          pt="32"
          mb="8"
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <ConnectSVG />
          </Box>

          <Box>
            <Text fontWeight={500} mb="8">
              Jumpstart your client planning
            </Text>
            <Text>
              To streamline the creation of your Financial Plans, you can set up data feeds so that
              Orion Planning can pull in your clients and their accounts.
              <Button
                variant="link"
                onClick={() => {
                  ADV.util.Router.go2('AdviserSettings', {
                    page: 'DataFeedsSettings',
                  });
                }}
              >
                Click here to get started with setting up your feed.
              </Button>{' '}
            </Text>
          </Box>

          <Separator />

          <Box>
            <Text fontWeight={500} mb="8">
              Looking to explore plans or get some help with onboarding?
            </Text>
            <Text>
              Create a demo client with sample data to explore Orion Planning. Test features, view
              sample goals and portfolios or visit our{' '}
              <Link href={`${ADV.info.resourceCenterUrl}financial-planning`}>Training Center</Link>{' '}
              for documentation.
            </Text>
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            css={({ theme }) => ({
              gap: theme.space['8'],
            })}
          >
            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              bg="neutral.100"
              p="8"
              css={({ theme }) => ({
                borderRadius: theme.radii.xl,
                gap: theme.space['16'],
              })}
            >
              <Box>
                <Text fontWeight={500}>Mid-Career Builder</Text>
                <Text>30s professional seeking planning for family and retirement.</Text>
              </Box>

              <Button
                width="100%"
                variant="secondary"
                onClick={() => {
                  window.open(`${demoURI}&masterSampleClientId=${sampleClients?.[1].id}`, '_blank');
                }}
              >
                View Sample Plan
              </Button>
            </Box>

            <Box
              width="100%"
              display="flex"
              flexDirection="column"
              bg="neutral.100"
              p="8"
              css={({ theme }) => ({
                borderRadius: theme.radii.xl,
                gap: theme.space['16'],
              })}
            >
              <Box>
                <Text fontWeight={500}>Retirement Approacher</Text>
                <Text>Focused on wealth preservation and family legacy.</Text>
              </Box>

              <Button
                width="100%"
                variant="secondary"
                onClick={() => {
                  window.open(`${demoURI}&masterSampleClientId=${sampleClients?.[0].id}`, '_blank');
                }}
              >
                View Sample Plan
              </Button>
            </Box>
          </Box>
        </Box>
      </ModalBody>

      <ModalFooter hasBorder>
        <Button
          ml="8"
          onClick={() => {
            onClose();
          }}
          rightIcon="fas fa-caret-right"
        >
          Get Started
        </Button>
      </ModalFooter>
    </>
  );
};
